import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import React from "react";

const WorkflowIconSvg: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0732 3.2168C16.4267 3.21682 16.7157 3.50594 16.7158 3.85938V8.68262H19.2871V3.85938C19.2873 3.50593 19.5772 3.2168 19.9307 3.2168H32.1445C32.498 3.2168 32.787 3.50593 32.7871 3.85938V16.0742C32.787 16.4277 32.498 16.7168 32.1445 16.7168H19.9307C19.5772 16.7168 19.2873 16.4277 19.2871 16.0742V11.2539H16.7158V16.0742C16.7157 16.4277 16.4267 16.7168 16.0732 16.7168H11.2402V19.2998H16.0732C16.4267 19.2998 16.7157 19.5889 16.7158 19.9424V24.2637H24.9883V21.499C24.9885 21.2581 25.2702 21.1219 25.459 21.2705L30.585 25.3203C30.6197 25.3471 30.6486 25.3815 30.668 25.4209C30.6872 25.4601 30.6972 25.5033 30.6973 25.5469C30.6973 25.5907 30.6873 25.6345 30.668 25.6738C30.6486 25.7132 30.6197 25.7476 30.585 25.7744L25.4629 29.8242C25.2742 29.9728 24.9925 29.8405 24.9922 29.5957V26.835H16.7158V32.1572C16.7157 32.5107 16.4267 32.7998 16.0732 32.7998H3.85938C3.5059 32.7998 3.21597 32.5107 3.21582 32.1572V19.9424C3.21597 19.5889 3.5059 19.2998 3.85938 19.2998H8.66895V16.7168H3.85938C3.5059 16.7168 3.21597 16.4277 3.21582 16.0742V3.85938C3.21597 3.50593 3.5059 3.2168 3.85938 3.2168H16.0732ZM5.94824 30.0674H13.9844V22.0322H5.94824V30.0674ZM5.94824 13.9844H13.9844V5.94922H5.94824V13.9844ZM22.0195 13.9844H30.0557V5.94922H22.0195V13.9844Z"
      fillOpacity="0.85"
    />
  </svg>
);

export const WorkflowIcon: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => <Icon component={WorkflowIconSvg} {...props} />;
